// src/features/featuresSlice.ts

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface FeaturesState {
  searchBar: boolean;
  newsSection: boolean;
  sidebarTopics: boolean;
  homeTab: boolean;
  historyTab: boolean;
  faqsTab: boolean
}

const initialState: FeaturesState = {
	searchBar: true,
	newsSection: true,
	sidebarTopics: true,
	homeTab: true,
	historyTab: true,
	faqsTab: true
};

interface ToggleFeaturePayload {
  feature: keyof FeaturesState;
}

interface SetFeatureStatePayload {
  feature: keyof FeaturesState;
  enabled: boolean;
}

const featuresSlice = createSlice({
  name: 'features',
  initialState,
  reducers: {
    toggleFeature: (state, action: PayloadAction<ToggleFeaturePayload>) => {
      const { feature } = action.payload;
      state[feature] = !state[feature];
    },
    setFeatureState: (state, action: PayloadAction<SetFeatureStatePayload>) => {
      const { feature, enabled } = action.payload;
      state[feature] = enabled;
    },
	disableAll: (state) => {
		state.searchBar = false;
		state.newsSection = false;
		state.sidebarTopics = false;
		state.homeTab = false;
		state.historyTab = false;
		state.faqsTab = false;
	  },
	  enableAll: (state) => {
		state.searchBar = true;
		state.newsSection = true;
		state.sidebarTopics = true;
		state.homeTab = true;
		state.historyTab = true;
		state.faqsTab = true;
	  },
  },
});

export const { toggleFeature, setFeatureState, disableAll, enableAll } = featuresSlice.actions;
export default featuresSlice.reducer;
